// Places the default location at the beginning of the list
export const formatSavedLocations = (savedLocations, defaultLocationId) => {
  if (savedLocations && defaultLocationId) {
    const defaultLocation = savedLocations?.find(
      savedLocation => savedLocation.deliveryLocationId === defaultLocationId,
    )
    if (defaultLocation) {
      savedLocations.splice(savedLocations.indexOf(defaultLocation), 1)
      savedLocations.unshift(defaultLocation)
    }

    return savedLocations
  }
}
